import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./scss/index.scss";
import React from "react";
import { useAuth } from "@saleor/sdk";
import { Loader } from "@components/atoms";
import ReactSVG from "react-svg";
import { useNavigate } from "react-router-dom";
import LoginManager from "../LoginManager";

var closeWhite = require("../../images/closewhite.svg");

export var alertLogin = function alertLogin(_ref) {
  var _JSON$parse, _JSON$parse$mainTrade;

  var hideModal = _ref.hideModal,
      data = _ref.data,
      useCurrentTrade = _ref.useCurrentTrade;

  var _useAuth = useAuth(),
      user = _useAuth.user,
      validateCustomerAnonymousCode = _useAuth.validateCustomerAnonymousCode,
      verifyCustomerAccount = _useAuth.verifyCustomerAccount;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      seeCode = _React$useState2[0],
      setSeeCode = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      showValidateCode = _React$useState4[0],
      setShowValidateCode = _React$useState4[1];

  var _React$useState5 = React.useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      loading = _React$useState6[0],
      setLoading = _React$useState6[1];

  var _React$useState7 = React.useState(false),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      resendCode = _React$useState8[0],
      setResendCode = _React$useState8[1];

  var _React$useState9 = React.useState([]),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      errorsValidateCode = _React$useState10[0],
      setErrorsValidateCode = _React$useState10[1];

  var _React$useState11 = React.useState([]),
      _React$useState12 = _slicedToArray(_React$useState11, 2),
      errorsVerifyAccount = _React$useState12[0],
      setErrorsVerifyAccount = _React$useState12[1];

  var _React$useState13 = React.useState(""),
      _React$useState14 = _slicedToArray(_React$useState13, 2),
      codeState = _React$useState14[0],
      setCodeState = _React$useState14[1];

  var _React$useState15 = React.useState(""),
      _React$useState16 = _slicedToArray(_React$useState15, 2),
      userWaNumber = _React$useState16[0],
      setUserWaNumber = _React$useState16[1];

  var defaultCountryCode = localStorage.getItem("mainTrade") !== null && localStorage.getItem("mainTrade") !== undefined && localStorage.getItem("mainTrade") ? (_JSON$parse = JSON.parse(localStorage.getItem("mainTrade") || "{}")) === null || _JSON$parse === void 0 ? void 0 : (_JSON$parse$mainTrade = _JSON$parse.mainTradeData) === null || _JSON$parse$mainTrade === void 0 ? void 0 : _JSON$parse$mainTrade.countryCode : "CO";

  var _React$useState17 = React.useState({}),
      _React$useState18 = _slicedToArray(_React$useState17, 2),
      userData = _React$useState18[0],
      setUserData = _React$useState18[1];

  var _React$useState19 = React.useState({
    userId: null,
    currentTradeId: null
  }),
      _React$useState20 = _slicedToArray(_React$useState19, 2),
      verifyCustomer = _React$useState20[0],
      setVerifyCustomer = _React$useState20[1];

  var navigate = useNavigate();

  var handleLogIn = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e, userWaNumber) {
      var _user$currentTrade, _verify$data, _verify$data$user, _verify$data2, _verify$data3, _verify$data4, _verify$data5, _verify$data6, verify, _verify$data7, _verify$data8, _verify$data9, _verify$data10, _verify$data11, _verify$data11$user, _verify$data12;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();

              if (!(userWaNumber !== "" && userWaNumber !== undefined)) {
                _context.next = 11;
                break;
              }

              setLoading(true);
              _context.next = 5;
              return verifyCustomerAccount(+atob((data === null || data === void 0 ? void 0 : data.id) || (user === null || user === void 0 ? void 0 : (_user$currentTrade = user.currentTrade) === null || _user$currentTrade === void 0 ? void 0 : _user$currentTrade.idMainTrade)).split(":")[1], userWaNumber, useCurrentTrade);

            case 5:
              verify = _context.sent;
              setVerifyCustomer({
                userId: verify === null || verify === void 0 ? void 0 : (_verify$data = verify.data) === null || _verify$data === void 0 ? void 0 : (_verify$data$user = _verify$data.user) === null || _verify$data$user === void 0 ? void 0 : _verify$data$user.id,
                currentTradeId: verify === null || verify === void 0 ? void 0 : (_verify$data2 = verify.data) === null || _verify$data2 === void 0 ? void 0 : _verify$data2.currentTradeId
              });

              if ((verify === null || verify === void 0 ? void 0 : (_verify$data3 = verify.data) === null || _verify$data3 === void 0 ? void 0 : _verify$data3.userWaNumber) && (verify === null || verify === void 0 ? void 0 : (_verify$data4 = verify.data) === null || _verify$data4 === void 0 ? void 0 : _verify$data4.userWaNumber) !== null && (verify === null || verify === void 0 ? void 0 : (_verify$data5 = verify.data) === null || _verify$data5 === void 0 ? void 0 : _verify$data5.userWaNumber) !== undefined && (verify === null || verify === void 0 ? void 0 : (_verify$data6 = verify.data) === null || _verify$data6 === void 0 ? void 0 : _verify$data6.userWaNumber) !== "") {
                setUserData({
                  accessCodeSeconds: verify === null || verify === void 0 ? void 0 : (_verify$data7 = verify.data) === null || _verify$data7 === void 0 ? void 0 : _verify$data7.accessCodeSeconds,
                  siteSettings: verify === null || verify === void 0 ? void 0 : (_verify$data8 = verify.data) === null || _verify$data8 === void 0 ? void 0 : _verify$data8.siteSettings,
                  userWaNumber: verify === null || verify === void 0 ? void 0 : (_verify$data9 = verify.data) === null || _verify$data9 === void 0 ? void 0 : _verify$data9.userWaNumber,
                  userHasAcceptedTyc: !!((verify === null || verify === void 0 ? void 0 : (_verify$data10 = verify.data) === null || _verify$data10 === void 0 ? void 0 : _verify$data10.user) !== null ? verify === null || verify === void 0 ? void 0 : (_verify$data11 = verify.data) === null || _verify$data11 === void 0 ? void 0 : (_verify$data11$user = _verify$data11.user) === null || _verify$data11$user === void 0 ? void 0 : _verify$data11$user.hasAcceptedTyc : verify === null || verify === void 0 ? void 0 : (_verify$data12 = verify.data) === null || _verify$data12 === void 0 ? void 0 : _verify$data12.user)
                });
                setShowValidateCode(true);

                if (errorsVerifyAccount.length > 0) {
                  setErrorsVerifyAccount([]);
                }
              } else if ((verify === null || verify === void 0 ? void 0 : verify.dataError.error.length) > 0) {
                setErrorsVerifyAccount(verify === null || verify === void 0 ? void 0 : verify.dataError.error);
              }

              setLoading(false);
              _context.next = 12;
              break;

            case 11:
              setErrorsVerifyAccount([{
                code: "WA_NUMBER_REQUIRED",
                field: "userWaNumber",
                message: "El número de WhatsApp es requerido"
              }]);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleLogIn(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleChange = React.useCallback(function () {
    if (errorsVerifyAccount.length > 0) {
      setErrorsVerifyAccount([]);
    }

    setCodeState("");
    setShowValidateCode(false);
    setUserWaNumber("");
  }, [setShowValidateCode, setUserWaNumber]);

  var handleValidateCode = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e, code, userHasAcceptedTyc) {
      var _user$currentTrade2, _validate$dataError, _validate$dataError$e, validate, _validate$dataError2;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              e.preventDefault();

              if (!(code !== "" && code !== undefined)) {
                _context2.next = 22;
                break;
              }

              setLoading(true);

              if (!useCurrentTrade) {
                _context2.next = 9;
                break;
              }

              _context2.next = 6;
              return validateCustomerAnonymousCode(userData === null || userData === void 0 ? void 0 : userData.userWaNumber, +atob(verifyCustomer === null || verifyCustomer === void 0 ? void 0 : verifyCustomer.userId).split(":")[1], code, userHasAcceptedTyc, verifyCustomer === null || verifyCustomer === void 0 ? void 0 : verifyCustomer.currentTradeId);

            case 6:
              _context2.t0 = _context2.sent;
              _context2.next = 12;
              break;

            case 9:
              _context2.next = 11;
              return validateCustomerAnonymousCode(userData === null || userData === void 0 ? void 0 : userData.userWaNumber, +atob(user === null || user === void 0 ? void 0 : user.id).split(":")[1], code, userHasAcceptedTyc, +atob(user === null || user === void 0 ? void 0 : (_user$currentTrade2 = user.currentTrade) === null || _user$currentTrade2 === void 0 ? void 0 : _user$currentTrade2.id).split(":")[1]);

            case 11:
              _context2.t0 = _context2.sent;

            case 12:
              validate = _context2.t0;

              if (!((validate === null || validate === void 0 ? void 0 : (_validate$dataError = validate.dataError) === null || _validate$dataError === void 0 ? void 0 : (_validate$dataError$e = _validate$dataError.error) === null || _validate$dataError$e === void 0 ? void 0 : _validate$dataError$e.length) > 0)) {
                _context2.next = 17;
                break;
              }

              setErrorsValidateCode(validate === null || validate === void 0 ? void 0 : (_validate$dataError2 = validate.dataError) === null || _validate$dataError2 === void 0 ? void 0 : _validate$dataError2.error);
              setLoading(false);
              return _context2.abrupt("return");

            case 17:
              if (errorsValidateCode.length > 0) {
                setErrorsValidateCode([]);
              }

              setLoading(false);
              hideModal();
              _context2.next = 23;
              break;

            case 22:
              setErrorsValidateCode([{
                code: "CODE_REQUIRED",
                field: "code",
                message: "El código es requerido"
              }]);

            case 23:
              if (useCurrentTrade) {
                navigate("/account/", {
                  state: {
                    from: "account",
                    customVar: true
                  }
                });
              }

            case 24:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleValidateCode(_x3, _x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }();

  var handleReSendCode = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(waNumber) {
      var _user$currentTrade3, _verify$data13, _verify$data14, _verify$data15, _verify$data16, _verify$dataError, _verify$dataError$err, _verify$dataError2, _verify$dataError2$er, verify, _verify$data17, _verify$data18, _verify$data19, _verify$data20, _verify$data20$user, _verify$data21;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              setErrorsValidateCode([]);
              setErrorsVerifyAccount([]);

              if (!(userWaNumber !== "" && userWaNumber !== undefined)) {
                _context3.next = 13;
                break;
              }

              setLoading(true);
              _context3.next = 6;
              return verifyCustomerAccount(+atob((data === null || data === void 0 ? void 0 : data.id) || (user === null || user === void 0 ? void 0 : (_user$currentTrade3 = user.currentTrade) === null || _user$currentTrade3 === void 0 ? void 0 : _user$currentTrade3.idMainTrade)).split(":")[1], userWaNumber);

            case 6:
              verify = _context3.sent;

              if ((verify === null || verify === void 0 ? void 0 : (_verify$data13 = verify.data) === null || _verify$data13 === void 0 ? void 0 : _verify$data13.userWaNumber) && (verify === null || verify === void 0 ? void 0 : (_verify$data14 = verify.data) === null || _verify$data14 === void 0 ? void 0 : _verify$data14.userWaNumber) !== null && (verify === null || verify === void 0 ? void 0 : (_verify$data15 = verify.data) === null || _verify$data15 === void 0 ? void 0 : _verify$data15.userWaNumber) !== undefined && (verify === null || verify === void 0 ? void 0 : (_verify$data16 = verify.data) === null || _verify$data16 === void 0 ? void 0 : _verify$data16.userWaNumber) !== "") {
                setUserData({
                  accessCodeSeconds: verify === null || verify === void 0 ? void 0 : (_verify$data17 = verify.data) === null || _verify$data17 === void 0 ? void 0 : _verify$data17.accessCodeSeconds,
                  siteSettings: verify === null || verify === void 0 ? void 0 : (_verify$data18 = verify.data) === null || _verify$data18 === void 0 ? void 0 : _verify$data18.siteSettings,
                  userWaNumber: verify === null || verify === void 0 ? void 0 : (_verify$data19 = verify.data) === null || _verify$data19 === void 0 ? void 0 : _verify$data19.userWaNumber,
                  userHasAcceptedTyc: !!((verify === null || verify === void 0 ? void 0 : (_verify$data20 = verify.data) === null || _verify$data20 === void 0 ? void 0 : (_verify$data20$user = _verify$data20.user) === null || _verify$data20$user === void 0 ? void 0 : _verify$data20$user.hasAcceptedTyc) || (verify === null || verify === void 0 ? void 0 : (_verify$data21 = verify.data) === null || _verify$data21 === void 0 ? void 0 : _verify$data21.user))
                });
                setShowValidateCode(true);

                if (errorsVerifyAccount.length > 0) {
                  setErrorsVerifyAccount([]);
                }
              } else if ((verify === null || verify === void 0 ? void 0 : (_verify$dataError = verify.dataError) === null || _verify$dataError === void 0 ? void 0 : (_verify$dataError$err = _verify$dataError.error) === null || _verify$dataError$err === void 0 ? void 0 : _verify$dataError$err.length) > 0) {
                setErrorsValidateCode(verify === null || verify === void 0 ? void 0 : verify.dataError.error);
              }

              setResendCode(function (resendCodePrev) {
                return !resendCodePrev;
              });
              setCodeState("");
              setSeeCode(false);

              if ((verify === null || verify === void 0 ? void 0 : (_verify$dataError2 = verify.dataError) === null || _verify$dataError2 === void 0 ? void 0 : (_verify$dataError2$er = _verify$dataError2.error) === null || _verify$dataError2$er === void 0 ? void 0 : _verify$dataError2$er.length) === 0) {
                setErrorsValidateCode([{
                  code: "SEND_NEW_CODE_WA",
                  field: "code",
                  message: "Te hemos enviado un nuevo código, porfavor revisa tu WhatsApp"
                }]);
              }

              setLoading(false);

            case 13:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleReSendCode(_x6) {
      return _ref4.apply(this, arguments);
    };
  }();

  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "alertLogin"
  }), React.createElement("div", {
    className: "alertLogin__data"
  }, React.createElement("div", {
    className: "alertLogin__data__close"
  }, React.createElement("p", null, "Iniciar sesi\xF3n"), React.createElement(ReactSVG, {
    path: closeWhite,
    onClick: hideModal
  })), React.createElement("div", {
    className: "alertLogin__data__content"
  }, React.createElement("p", null, "Ingresa tu n\xFAmero de WhatsApp para identificarte:"), React.createElement("form", {
    className: "alertLogin__data__content__form"
  }, React.createElement(LoginManager, {
    accessCodeSeconds: userData === null || userData === void 0 ? void 0 : userData.accessCodeSeconds,
    buttonAccessLabel: "Ingresar",
    classNameButton: "alertLogin__data__content__logInButton",
    showValidateCode: showValidateCode,
    defaultCountryCode: defaultCountryCode,
    userWaNumber: userWaNumber,
    setUserWaNumber: setUserWaNumber,
    errorsVerifyAccount: errorsVerifyAccount,
    seeCode: seeCode,
    errorsValidateCode: errorsValidateCode,
    code: codeState,
    resendCode: resendCode,
    siteSettings: userData === null || userData === void 0 ? void 0 : userData.siteSettings,
    userHasAcceptedTyc: userData === null || userData === void 0 ? void 0 : userData.userHasAcceptedTyc,
    handleChange: handleChange,
    handleCodeInput: function handleCodeInput(codeValue) {
      return setCodeState(codeValue);
    },
    handleSeeCode: function handleSeeCode() {
      return setSeeCode(!seeCode);
    },
    handleValidateCode: handleValidateCode,
    handleReSendCode: handleReSendCode,
    handleLogIn: handleLogIn
  }))), loading && React.createElement("div", {
    className: "alertLogin__loading"
  }, React.createElement(Loader, null))));
};
export default alertLogin;